import {
  AvatarCountry,
  CardContent,
  ContentIsland,
  DateTime,
  Grid,
  Money,
  Stack,
  TimerChip,
  Typography,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiThreeDS } from '../../../openapi';
import { addSeconds } from 'date-fns';

function Details({ label, value }: { label: React.ReactNode; value: React.ReactNode }) {
  return (
    <Stack spacing={2} justifyContent="space-between" width="100%">
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {value}
    </Stack>
  );
}

export function ThreeDSDetails({ threeDS }: { threeDS: ApiThreeDS }) {
  const { t } = useTranslation();

  return (
    <ContentIsland
      title={t('Transaction Details')}
      actions={
        threeDS.state === 'PENDING' ? (
          <TimerChip endsAt={addSeconds(threeDS.createdAt, threeDS.lifeTimeInSec)} hideOnceEnded />
        ) : null
      }
    >
      <CardContent>
        <Stack spacing={2}>
          <Grid container spacing={2}>
            <Grid size={6}>
              <Details
                label={t('Merchant')}
                value={
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <AvatarCountry country={threeDS.merchantInfo.country} size={20} />
                    <Typography>{threeDS.merchantInfo.name}</Typography>
                  </Stack>
                }
              />
            </Grid>

            <Grid size={6}>
              <Details label={t('Amount')} value={<Money value={threeDS.amount} />} />
            </Grid>

            <Grid size={6}>
              <Details
                label={t('Card')}
                value={<Typography>{`•••• ${threeDS.lastFour}`}</Typography>}
              />
            </Grid>

            <Grid size={6}>
              <Details label={t('Date')} value={<DateTime value={threeDS.createdAt} />} />
            </Grid>
          </Grid>
        </Stack>
      </CardContent>
    </ContentIsland>
  );
}
